module.exports = __webpack_public_path__ + "img/S9-2.34ceef6e.png";